<form [formGroup]="privacyTreatmentForm" class="form-validation" (ngSubmit)="onSubmit()">
  <div class="modal-header">
    <h4 class="modal-title pull-left" style="text-transform: uppercase;">{{modalTitle}}</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">

    <div class="row">

      <ng-template #ErrorMsg let-msg="msg" let-value="value" let-submitted="submitted">
        <div *ngFor="let validation of msg">
          <div class="error-message"
            *ngIf="value.hasError(validation.type) && (value.touched || value.dirty || submitted)">
            {{validation.message}}
          </div>
        </div>
      </ng-template>      

      <div class="form-group col-sm-12">
          <label>{{ lang?.code }}</label>
          <input type="text" class="form-control" formControlName="code"
            [ngClass]="formErrorClass(privacyTreatmentForm.controls?.code, privacyTreatmentFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:privacyTreatmentFormErrorMsg?.code, value:privacyTreatmentForm.controls?.code, submitted:privacyTreatmentFormSubmitted }">
          </ng-template>            
      </div>

        <div class="form-group col-sm-12">
          <label>{{ lang?.desc_of_treatment }}</label>
          <input type="text" class="form-control" formControlName="description_treatment"
            [ngClass]="formErrorClass(privacyTreatmentForm.controls?.description_treatment, privacyTreatmentFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:privacyTreatmentFormErrorMsg?.description_treatment, value:privacyTreatmentForm.controls?.description_treatment, submitted:privacyTreatmentFormSubmitted }">
          </ng-template>            
        </div>        


        <div class="form-group col-sm-12">
          <label>{{ lang?.type }}</label>
          <select class="form-control" formControlName="type"
            [ngClass]="formErrorClass (privacyTreatmentForm.controls.type, privacyTreatmentFormSubmitted)">
            <option [ngValue]="">{{ lang?.pleaseSelect }}</option>
            <option Value="common_data">{{ lang?.common_data }}</option>
            <option Value="sensitive_data">{{ lang?.sensitive_data }}</option>
          </select>
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:privacyTreatmentFormErrorMsg?.type, value:privacyTreatmentForm.controls?.type, submitted:privacyTreatmentFormSubmitted }">
          </ng-template>             
        </div>

      <div class="form-group col-sm-12">
        <label>{{ lang?.tools_data_processing }}</label>
        <select class="form-control" formControlName="tools_data_processing"
          [ngClass]="formErrorClass (privacyTreatmentForm.controls.tools_data_processing, privacyTreatmentFormSubmitted)">
          <option [ngValue]="">{{ lang?.pleaseSelect }}</option>
          <option Value="electronic">{{ lang?.electronic }}</option>
          <option Value="paper">{{ lang?.paper }}</option>
        </select>
        <ng-template [ngTemplateOutlet]="ErrorMsg"
        [ngTemplateOutletContext]="{msg:privacyTreatmentFormErrorMsg?.tools_data_processing, value:privacyTreatmentForm.controls?.tools_data_processing, submitted:privacyTreatmentFormSubmitted }">
      </ng-template>          
      </div>
      
      <div class="form-group col-sm-12">
          <label>{{ lang?.physical_location_data_storage }}</label>
          <input type="text" class="form-control" formControlName="physical_location_data_storage"
            [ngClass]="formErrorClass(privacyTreatmentForm.controls?.physical_location_data_storage, privacyTreatmentFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:privacyTreatmentFormErrorMsg?.physical_location_data_storage, value:privacyTreatmentForm.controls?.physical_location_data_storage, submitted:privacyTreatmentFormSubmitted }">
          </ng-template>            
      </div>

      <div class="form-group col-sm-12">
        <label>{{ lang?.type_access_computer_data }}</label>
        <input type="text" class="form-control" formControlName="type_access_to_computer_data"
          [ngClass]="formErrorClass(privacyTreatmentForm.controls?.type_access_to_computer_data, privacyTreatmentFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:privacyTreatmentFormErrorMsg?.type_access_to_computer_data, value:privacyTreatmentForm.controls?.type_access_to_computer_data, submitted:privacyTreatmentFormSubmitted }">
          </ng-template>          
      </div>      

      <div class="form-group col-sm-12">
        <label>{{ lang?.physical_location_data_archieve }}</label>
        <input type="text" class="form-control" formControlName="physical_location"
          [ngClass]="formErrorClass(privacyTreatmentForm.controls?.physical_location, privacyTreatmentFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:privacyTreatmentFormErrorMsg?.physical_location, value:privacyTreatmentForm.controls?.physical_location, submitted:privacyTreatmentFormSubmitted }">
          </ng-template>          
      </div>



      <div class="form-group col-sm-12">
        <label>{{ lang?.type_access_papper_data }}</label>
        <input type="text" class="form-control" formControlName="type_access_to_paper_data"
          [ngClass]="formErrorClass(privacyTreatmentForm.controls?.type_access_to_paper_data, privacyTreatmentFormSubmitted)">
          <ng-template [ngTemplateOutlet]="ErrorMsg"
            [ngTemplateOutletContext]="{msg:privacyTreatmentFormErrorMsg?.type_access_to_paper_data, value:privacyTreatmentForm.controls?.type_access_to_paper_data, submitted:privacyTreatmentFormSubmitted }">
          </ng-template>          
      </div>


    </div>
  </div>

  <div class="modal-footer">
    <button type="submit" class="btn btn-success">{{ lang?.save }}</button>
    <button type="button" class="btn btn-warning" (click)="bsModalRef.hide()">{{ lang?.close }}</button>
  </div>
</form>